export default ({keys, server}) => `package com.stripe.example;

import androidx.recyclerview.widget.RecyclerView;

import com.google.android.material.button.MaterialButton;

import org.jetbrains.annotations.NotNull;

// A simple [RecyclerView.ViewHolder] that contains a representation of each discovered reader
public class ReaderHolder extends RecyclerView.ViewHolder {
    public final MaterialButton view;

    public ReaderHolder(@NotNull MaterialButton view) {
        super(view);
        this.view = view;
    }
}
`;
